export default __webpack_public_path__ + "static/media/32_SchererGruppe-DTM-Documentary-EschweilerPhotography_21A3907.67a7106a.jpg";